import { render, staticRenderFns } from "./AddUserIcon.vue?vue&type=template&id=aa3bf7ae&scoped=true"
import script from "./AddUserIcon.vue?vue&type=script&lang=js"
export * from "./AddUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3bf7ae",
  null
  
)

export default component.exports